import styled from "styled-components";

export const EducationContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  align-items: left;
  /* width: 100vw; */
  margin-block: 2rem;

`;
export const EducationCard = styled.div`
  display: flex;
  overflow: hidden;
  border-radius: 1em;
  background: linear-gradient(to right, #ffffff, #ece9e6);
  margin: 20px 0px;
  width: 90vw;
`;
export const EducationBody = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  text-align: left;
  align-items: left;
  width: 75%;
  padding: 25px 25px;
  @media only screen and (max-width: 1280px) {
    padding: 10px 0px;
    width: 90%;

}
  h4 {
  font-size: 1.5rem;
  text-transform: capitalize;
  
}
h5 {
  font-size: 1rem;
  text-transform: capitalize;
  padding-left:1rem;
}
p{
  font-size: 1rem;
  text-transform: capitalize;
  padding-left:2rem;
}
ul{
  font-size: 1rem;
  text-transform: capitalize;
  padding-left:3rem;
}
`;

